import { LinkButton, Icon, Typography } from "@bca/ui-library";
import React from "react";
import { useSelector, useDispatch } from "react-redux";

import analytics from "../common/analytics/analytics";
import { IEventPushable } from "../common/analytics/analytics.types";
import { StoreType } from "../StoreType";
import { Links } from "../vehicle-search-details/vehicleSearch.type";
import { handlePrintExportFile } from "../utils/handlePrintExportFile";
import { GET_STATE } from "../redux/slices/appSlice";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

const pushExportAllAnalytics = () => {
  analytics.push<IEventPushable>({
    event: {
      name: "click",
      category: "link",
      label: "export",
      action: "export",
      section: "search-ellipsis",
    },
  });
};

const ExportAllButton: React.FunctionComponent<{
  exportAllLink: Links;
  pdfEnabled?: boolean;
}> = ({ exportAllLink, pdfEnabled }) => {
  const dispatch = useDispatch();
  const {
    app: { isLoadingFile, isToUseAuthZero },
  }: StoreType = useSelector(GET_STATE);

  const { accessToken } = useAuth(!isToUseAuthZero);

  const handleExportFile = () => {
    if (pdfEnabled && Boolean(exportAllLink?.href)) {
      handlePrintExportFile(
        dispatch,
        exportAllLink.href,
        exportAllLink.rel,
        accessToken,
        isToUseAuthZero
      );
      pushExportAllAnalytics();
    }
  };

  return (
    <LinkButton
      data-testid="ellipsis-export-all"
      variant="tertiary"
      height="30px"
      px={0}
      target="_blank"
      href={
        !pdfEnabled && Boolean(exportAllLink?.href) ? exportAllLink.href : null
      }
      onClick={handleExportFile}
      css={
        (!Boolean(exportAllLink?.href) || isLoadingFile) &&
        `
        opacity: 0.3;
        cursor: default;
      `
      }
    >
      <Icon
        width="16px"
        name="file-export"
        weight="regular"
        color="primary-light-blue"
        mb="2px"
        mr={2}
      ></Icon>
      <Typography
        color="primary-light-blue"
        variant="body"
        my="0"
        css={`
          text-decoration: underline;
        `}
      >
        Export all to Excel
      </Typography>
    </LinkButton>
  );
};

export default ExportAllButton;
